const routes = {
  index: '/',
  login: '/login/',
  register: '/register/',
  forgotPassword: '/forgot-password/',
  logout: '/logout/',
  registerSuccess: '/register-success/',
  dashboard: '/dashboard/',
  account: '/account/',
  cgpDocumentUpload: '/cgp/documents/upload/[token]/',
  marketplace: '/marketplace/',
  properties: '/properties/',
  property: '/properties/[propertyId]/',
  checkoutQueue: '/properties/[propertyId]/checkout/queue',
  checkoutOverview: '/properties/[propertyId]/checkout/overview',
  checkoutTimeout: '/properties/[propertyId]/checkout/timeout',
  checkoutComplete: '/properties/[propertyId]/checkout/complete/',
  checkout: '/properties/[propertyId]/checkout/',
  order: '/orders/[orderId]/',
  orderSignature: '/orders/[orderId]/sign',
  teaser: '/teaser/',
}

export default routes
